import { ChatBubbleOutline } from "@mui/icons-material";
import ChatAvatar from "./ChatAvatar";
import { chatTitle } from "../lib/presentation";

/** Frontend-style header without inventing peer presence information. */
export default function ChatRoomHeader({ chat, connected, onOpenList }) {
  return <header className="dk-chat-room-header">
    <button type="button" className="dk-chat-icon dk-chat-mobile-menu" onClick={onOpenList}
      aria-label="گفتگوها"><ChatBubbleOutline /></button>
    <ChatAvatar chat={chat} header />
    <div className="dk-chat-header-copy"><h2>{chatTitle(chat)}</h2>
      <p>{!connected ? "در حال اتصال…" : chat?.isOnline === true ? "آنلاین" : "پیام‌های گفتگو"}</p></div>
    <span className={`dk-chat-connection${connected ? " is-connected" : ""}`} role="status">
      <span aria-hidden="true" />{connected ? "متصل" : "در حال اتصال"}
    </span>
  </header>;
}
